import React from 'react';
import Producers from "../components/Producers";

const ProducersPage = () => {
    return (
        <React.Fragment >
            <Producers />
        </React.Fragment>
    );
};

export default ProducersPage;